import React, { useCallback, useEffect, useState } from 'react';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
// import * as yup from 'yup';
import { useService } from '../../../services/services';
import { FormMode } from '../../../enums/form-mode';
import { WorkOverviewItem } from './interfaces/work-overview-item';
import DashboardLoading from '../../dashboard/components/dashboard-loading';
import StaticTable, {
  StaticTableColumn,
} from '../../../components/common/table/static-table';
import { DecimalInputComponent } from '../../../components/form/elements/decimal';
import { TextInputComponent } from '../../../components/form/elements/text';
import { useNotes } from './components/use-notes';
import { TableHeader } from './components/table-header';
import RemoveIcon from './components/remove-icon';
import ValidationStatus from './components/validation-status';
import { StepProps } from './create';
import css from './index.module.css';

export default function StepWorkOverview({
  mode,
  setIsChildLoading,
}: StepProps) {
  const { t } = useTranslation();
  const transKeyPrefix = 'pages.crop.vaad_liz_reports_v2.work_overview.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { vaadLizReportV2Service: vaadLizReportService } = useService();
  const [tableData, setTableData] = useState<{
    rows: WorkOverviewItem[];
  } | null>(null);
  const [validationResultModal, setValidationResultModal] = useState(null);
  const { getNotesElement, modal } = useNotes('work_overview', mode, 'key');
  // const { setSchema } = useContext(SchemaContext);
  const form = useFormContext();
  const { setValue } = form;

  // todo:
  // const createSchema = useCallback((data: WorkOverviewItem[]) => {
  //   return yup.object().shape({});
  // }, []);

  // const createSchema2 = useCallback((data: WorkOverviewItem[]) => {
  //   const schema = yup.lazy(() =>
  //     yup.object().shape(
  //       data.reduce((schema, item) => {
  //         schema[item.id] = yup.object().shape({
  //           treated_area: yup.number().required(tp('validation.treated_area.required')),
  //           dose: yup.number().required(tp('validation.dose.required')),
  //           usage_reason: yup.string().when('product_type', {
  //             is: 'Augu aizsardzības līdzekļi',
  //             then: yup.string().required(tp('validation.usage_reason.required')),
  //             otherwise: yup.string().nullable(),
  //           }),
  //           recommended_dose: yup.number().when('product_value', {
  //             is: 'Kaļķošanas materiāls',
  //             then: yup.number().required(tp('validation.recommended_dose.required')),
  //             otherwise: yup.number().nullable(),
  //           }),
  //         });
  //         return schema;
  //       }, {})
  //     )
  //   );
  //
  //   return yup.object().shape({ work_overview: schema });
  // }, [tp]);
  //
  // const createSchema3 = useCallback((data: WorkOverviewItem[]) => {
  //   const workOverviewSchema = {};
  //
  //   data.forEach((item) => {
  //     workOverviewSchema[item.id] = yup.object().shape({
  //       treated_area: yup
  //         .number()
  //         // .required('Treated area is required'),
  //         .required(tp('validation.treated_area.required')),
  //       dose: yup
  //         .number()
  //         // .required('Dose is required'),
  //         .required(tp('validation.dose.required')),
  //       usage_reason: yup.string().when('product_type', {
  //         is: 'Augu aizsardzības līdzekļi',
  //         // then: yup.string().required('Usage reason is required'),
  //         then: yup.string().required(tp('validation.usage_reason.required')),
  //         otherwise: yup.string().nullable(),
  //       }),
  //       recommended_dose: yup.number().when('product_value', {
  //         is: 'Kaļķošanas materiāls',
  //         then: yup
  //           .number()
  //           // .required('Recommended dose is required'),
  //           .required(tp('validation.recommended_dose.required')),
  //         otherwise: yup.number().nullable(),
  //       }),
  //     });
  //   });
  //
  //   return yup.object().shape({
  //     work_overview: yup.object().shape(workOverviewSchema),
  //   });
  // }, [tp]);

  const onDataError = useCallback(
    (error) => {
      console.error('Error fetching data', error);
      setIsChildLoading(false);
    },
    [setIsChildLoading]
  );

  const transformWorksFromData = useCallback((data: WorkOverviewItem[]) => {
    const hideFieldsFor = { field_name: null, crop_value: null, area: null };
    const result: WorkOverviewItem[] = [];

    data.forEach((row) => {
      row?.works?.forEach((work) => {
        const workRow = { ...row, ...work };
        delete workRow.works;
        workRow.id_for_validation = row.id;

        if (
          hideFieldsFor.field_name === workRow.field_name &&
          hideFieldsFor.crop_value === workRow.crop_value &&
          hideFieldsFor.area === workRow.area
        ) {
          //
        } else {
          hideFieldsFor.field_name = workRow.field_name;
          hideFieldsFor.crop_value = workRow.crop_value;
          hideFieldsFor.area = workRow.area;

          workRow.field_name_value = `${workRow.field_nr || ''} - ${
            workRow.field_name
          }`;
          workRow.crop_value_value = workRow.crop_value;
          workRow.area_value = workRow.area;
        }

        result.push(workRow);
      });
      return row;
    });

    return result;
  }, []);

  // todo: test performance
  // const transformWorksFromData2 = useCallback(
  //   (data: WorkOverviewItem[]) => {
  //     const hideFieldsFor = { field_name: null, crop_value: null, area: null };
  //     const result: WorkOverviewItem[] = data.flatMap((row) => {
  //       row?.works?.sort(sortWorkOverviewItems);
  //       return row?.works?.map((work) => {
  //         const workRow = { ...row, ...work };
  //         delete workRow.works;
  //
  //         if (
  //           hideFieldsFor.field_name === workRow.field_name &&
  //           hideFieldsFor.crop_value === workRow.crop_value &&
  //           hideFieldsFor.area === workRow.area
  //         ) {
  //           return workRow;
  //         } else {
  //           hideFieldsFor.field_name = workRow.field_name;
  //           hideFieldsFor.crop_value = workRow.crop_value;
  //           hideFieldsFor.area = workRow.area;
  //
  //           workRow.field_name_value = `${workRow.field_nr || ''} - ${
  //             workRow.field_name
  //           }`;
  //           workRow.crop_value_value = workRow.crop_value;
  //           workRow.area_value = workRow.area;
  //         }
  //
  //         return workRow;
  //       }) || [];
  //     });
  //
  //     return result;
  //   },
  //   [sortWorkOverviewItems]
  // );

  const onDataLoad = useCallback(
    (data: WorkOverviewItem[]) => {
      const works = transformWorksFromData(data);

      const remove = (workId: string) => {
        setIsChildLoading(true);
        return vaadLizReportService.removeWork(farmId, id, workId).pipe(
          tap((data) => onDataLoad(data)),
          catchError((error) => {
            onDataError(error);
            return EMPTY;
          }),
          finalize(() => setIsChildLoading(false))
        );
      };

      const formValues = { work_overview: {} };

      const tableData: WorkOverviewItem[] = works.map((row) => {
        row.key = row.id;
        const name = `work_overview.${row.key}`;
        formValues.work_overview[row.key] = { ...row };

        const tableRow = { ...row };
        tableRow.key = tableRow.id;
        if (tableRow.field_name_value) {
          tableRow.status = (
            <ValidationStatus
              farmId={farmId}
              id={id}
              row={tableRow}
              setModal={setValidationResultModal}
              status={tp(`status.${tableRow.ecoscheme_validation_status}`)}
            />
          );
        } else {
          tableRow.status = null;
        }
        tableRow.treated_area = (
          <DecimalInputComponent
            name={name + '.treated_area'}
            disabled={mode === FormMode.view}
            negative={false}
          />
        );
        tableRow.product_name_value =
          tableRow.product_name || tableRow.product_value;
        tableRow.dose = (
          <DecimalInputComponent
            name={name + '.dose'}
            disabled={mode === FormMode.view}
            negative={false}
          />
        );
        if (tableRow.product_type === 'Augu aizsardzības līdzekļi') {
          tableRow.usage_reason = (
            <TextInputComponent
              name={name + '.usage_reason'}
              disabled={mode === FormMode.view}
            />
          );
        }
        if (tableRow.product_value === 'Kaļķošanas materiāls') {
          tableRow.recommended_dose = (
            <DecimalInputComponent
              name={name + '.recommended_dose'}
              disabled={mode === FormMode.view}
              negative={false}
            />
          );
        } else {
          tableRow.recommended_dose = null;
        }
        tableRow.service_provider = (
          <TextInputComponent
            name={name + '.service_provider'}
            disabled={mode === FormMode.view}
          />
        );
        tableRow.notes_edit = getNotesElement(name, tableRow);

        if (mode !== FormMode.view) {
          tableRow.remove = <RemoveIcon id={tableRow.id} onRemove={remove} />;
        }

        return tableRow;
      });

      // setSchema(createSchema(tableData));
      setTableData({ rows: tableData });
      setIsChildLoading(false);
      setValue('work_overview', formValues.work_overview);
    },
    [
      // createSchema,
      farmId,
      getNotesElement,
      id,
      mode,
      onDataError,
      setIsChildLoading,
      // setSchema,
      setValue,
      tp,
      transformWorksFromData,
      vaadLizReportService,
    ]
  );

  useEffect(() => {
    setIsChildLoading(true);

    const subscription: Subscription = vaadLizReportService
      .getWorkOverview(farmId, id)
      .subscribe(onDataLoad, onDataError);

    return () => subscription.unsubscribe();
  }, [
    farmId,
    id,
    onDataError,
    onDataLoad,
    setIsChildLoading,
    vaadLizReportService,
  ]);

  const columns = useCallback(() => {
    const baseColumns: StaticTableColumn<WorkOverviewItem>[] = [
      {
        accessor: 'field_name_value',
        header: tp('field_name'),
        className: css['strong'],
      },
      { accessor: 'status', header: tp('status.title') },
      { accessor: 'area_value', header: tp('area') },
      { accessor: 'crop_value_value', header: tp('crop_value') },
      { accessor: 'action_date', header: tp('action_date') },
      { accessor: 'work_type_value', header: tp('work_type_value') },
      { accessor: 'treated_area', header: tp('treated_area') },
      { accessor: 'product_type', header: tp('product_type') },
      { accessor: 'product_name_value', header: tp('product_name') },
      { accessor: 'dose', header: tp('dose') },
      { accessor: 'unit', header: tp('unit') },
      {
        accessor: 'usage_reason',
        header: (
          <TableHeader
            headerText={tp('usage_reason')}
            tooltipId="usage_reason-tooltip"
            tooltipText="pages.crop.vaad_liz_reports_v2.work_overview.tooltip.usage_reason"
            isRequired
          />
        ),
      },
      {
        accessor: 'recommended_dose',
        header: (
          <TableHeader
            headerText={tp('recommended_dose')}
            tooltipId="recommended_dose-tooltip"
            tooltipText="pages.crop.vaad_liz_reports_v2.work_overview.tooltip.recommended_dose"
            isRequired
          />
        ),
      },
      { accessor: 'service_provider', header: tp('service_provider') },
      { accessor: 'support_types', header: tp('support_types') },
      { accessor: 'notes_edit', header: tp('notes') },
    ];

    if (mode !== FormMode.view) {
      baseColumns.push({ accessor: 'remove', header: tp('remove') });
    }

    return baseColumns;
  }, [tp, mode]);

  return !tableData ? (
    <DashboardLoading />
  ) : (
    <div className={`${css['table']} ${css['works-table']}`}>
      <div className={css['list-warning']}>{tp('warning')}</div>
      <div className="clear-both" />

      <StaticTable<WorkOverviewItem>
        data={tableData}
        keyAccessor="key"
        columns={columns()}
        fixedHeight
      />

      {modal}
      {validationResultModal}
    </div>
  );
}
